import TargetLink from "@/components/TargetLink";
import CardArtwork from "@/components/Card/CardArtwork";
import { useSliderPosition } from "@/hooks";
import styles from "@/styles/Card.module.scss";
import { useRef } from "react";
import classnames from "classnames";

export default function AdvertCard(props) {
  const { item, intersect, rank, ...props_ } = props;
  const cardRef = useRef();
  const { classNames, active } = useSliderPosition(props_, cardRef);

  return (
    <div ref={cardRef} className={classnames(classNames)}>
      <TargetLink href={item.url} blank={item.targetBlank}>
        <div>
          <CardArtwork
            active={active}
            index={props_.index}
            focusIndex={props_.focusIndex}
            rank={rank}
            item={item}
            intersect={intersect}
          />
          <div className={styles.infoContainer}>
            <div className={styles.info}>
              <div className={styles.title}>
                <p>{item.name}</p>
              </div>
            </div>
            <div className={`${styles.feature} ${styles.info}`}>
              {props_.focusIndex != null && (
                <>
                  <div className={styles.title}>
                    <p>{item.name}</p>
                  </div>
                  <div className={styles.description}>
                    <p>{item.description}</p>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </TargetLink>
    </div>
  );
}
